// extracted by mini-css-extract-plugin
export default {"root":"J4jJ9OOknNi9iU8losSJ","local":"JzmB9Saqr_aVQR4xJhHP"};